module.exports = __webpack_public_path__ + "img/IMG_1855.fbc94598.jpeg";